export const getCommonParentDomain = (hostname: string, callbackHostname: string) => {
  const labels = hostname.split('.').reverse();
  const callbackLabels = callbackHostname.split('.').reverse();
  const commonLabels: string[] = [];

  for (const [index, label] of labels.entries()) {
    if (label !== callbackLabels[index]) {
      break;
    }
    commonLabels.unshift(label);
  }

  return commonLabels.join('.');
};
